
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IAppUserPayload } from '@src/types/api/app-user';
import { IDashboardStats } from '../../../types/api/app-user';


export async function detailUser(type:string): Promise<AxiosResponse<TResponse<IAppUserPayload>>> {
    return axios.get(`${API_ENDPOINTS.USER_DETAIL}/${type}`)
}


export async function dashboardStats(): Promise<AxiosResponse<TResponse<IDashboardStats>>> {
    return axios.get(`${API_ENDPOINTS.DASHBOARD_STATS}`)
}


export async function listUser(qData: QData): Promise<AxiosResponse<TResponseWithQData<IAppUserPayload[]>>> {
    return axios.get(API_ENDPOINTS.USER_LIST, {
        params: qData
    })
}

